import React, { PureComponent, Component } from 'react';
import JSONSchemaForm from '@rjsf/core';
import validator from '@rjsf/validator-ajv8';
import createStyledComponent from '../utils/createStyledComponent.js';
import styles from './styles/index.js';
import Button from '../Button/index.js';
import customWidgets from './widgets.js';
const FormContainer = createStyledComponent(styles, JSONSchemaForm);
/**
 * Wrapper around [`react-jsonschema-form`](https://github.com/rjsf-team/react-jsonschema-form) with custom widgets.
 */
export default class Form extends (PureComponent || Component) {
    render() {
        const { widgets, children, submitText, primaryButton, noSubmit, ...rest } = this.props;
        return (React.createElement(FormContainer, { ...rest, validator: validator, widgets: { ...customWidgets, ...widgets } }, noSubmit ? (React.createElement("noscript", null)) : (children || (React.createElement(Button, { size: "big", primary: primaryButton, theme: rest.theme, type: "submit" }, submitText || 'Submit')))));
    }
}
